import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 21;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g fill={color}>
      <path d="M15.571.893l4.95 4.95L7.086 19.278.368 21.046l1.768-6.718L15.571.893z" />
      <path d="M17.692 8.672l-8.485 8.485-1.414-1.414 7.071-7.071-4.243-4.243-4.95 4.95-1.414-1.415 6.364-6.363 7.071 7.071z" />
    </g>
  </svg>
);
